import getApiUrl from 'src/config/api';
import ImgProxyUrl, { ImgExt } from 'src/config/imgproxy';

const DPIS = [1, 1.5, 2, 2.5, 3];

export function getOptions(options) {
    if (options) {
        return `${options}/`;
    }
    return '';
}

function getApiImageUrlBase64(restaurantId, imageId) {
    return Buffer.from(`${getApiUrl()}/api/restaurant/restaurants/${restaurantId}/images/${imageId}`).toString('base64');
}

export const getUrl = (restaurantId, imageId, options = null) => {
    if (ImgProxyUrl) {
        return `${ImgProxyUrl}/${getOptions(options)}${getApiImageUrlBase64(restaurantId, imageId)}${ImgExt}`;
    } else {
        return `${getApiUrl()}/api/restaurant/restaurants/${restaurantId}/images/${imageId}`;
    }
};

export const getSrcSetUrls = (restaurantId, imageId, options) => DPIS.reduce((srcset, dpi) => {
    if (dpi === 1) {
        return getUrl(restaurantId, imageId, options);
    }

    return `${srcset}, ${getUrl(restaurantId, imageId, `${options}/dpr:${dpi}`)} ${dpi}x`;
}, '');
